export const showChatOptions = () => {
	const chatOptionsContainer = document.getElementById('chat-options');
	if(!chatOptionsContainer) return
	chatOptionsContainer.classList.remove('hidden');
}
